<template>
  <div class="layer layer2">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">{{ locale.product_detail }}</h2>
      <div class="info">
        <div class="mb30 isRequired">
          <div class="innerTitle setLabel">{{locale.name}}</div>
          <input type="text" class="input" v-model="name">
          <span class="checkbox">
            <input type="checkbox" id="desc_position_bottom" v-model="descPositionBottom">
            <label for="desc_position_bottom">설명 영역 하단에 표시</label>
          </span>
        </div>
        <div class="mb30 isRequired">
          <div class="innerTitle setLabel">{{ locale.title }}</div>
          <SetLanguageValue
            :locale="locale"
            :langValue="title"
            :textarea="true" />
          <div class="mt10">
            <p>{{ locale.font_size }}</p>
            <InputRange
              :min="1"
              :max="5"
              :step="1"
              :minLabel="locale.small"
              :maxLabel="locale.large"
              :value="fontSize.title"
              @setRange="setFontSizeRange('title', $event)" />
          </div>
        </div>
        <div class="isRequired">
          <div class="innerTitle setLabel">{{ locale.description }}</div>
          <SetLanguageValue
            :locale="locale"
            :langValue="desc"
            :textarea="true" />
          <div class="mt10">
            <p>{{ locale.font_size }}</p>
            <InputRange
              :min="1"
              :max="5"
              :step="1"
              :minLabel="locale.small"
              :maxLabel="locale.large"
              :value="fontSize.desc"
              @setRange="setFontSizeRange('desc', $event)" />
          </div>
        </div>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" :disabled="!isValid" @click="save">{{ locale.save }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import ColorPicker from '@/components/Util/ColorPicker.vue'
import SetLanguageValue from '@/components/Util/SetLanguageValue'
import InputRange from '@/components/Util/InputRange'

export default {
  name: 'CompositeStatus',
  props: [
    'locale',
    'presetId'
  ],
  components: {
    ColorPicker,
    SetLanguageValue,
    InputRange
  },
  computed: {
    currentLang () {
      return this.$store.getters['getLanguageObj']?.selected || 'ko'
    },
    isValid () {
      const lang = this.currentLang
      const name = regExp.replaceAllEmpty(this.name) !== ''
      const isValidTitle = regExp.replaceAllEmpty(this.title[lang]) !== ''
      const isValidDesc = regExp.replaceAllEmpty(this.desc[lang]) !== ''
      return name && (isValidTitle || isValidDesc)
    }
  },
  created () {
    if (this.presetId && this.presetId !== 'new') {
      this.getShopPresetDetail()
    }
  },
  data () {
    return {
      name: '',
      title: LANG.valueObj(''),
      desc: LANG.valueObj(''),
      fontSize: {
        title: 3,
        desc: 3
      },
      descPositionBottom: false
    }
  },
  methods: {
    setFontSizeRange (target, value) {
      this.fontSize[target] = value
    },
    async getShopPresetDetail () {
      this.$store.commit('onLoading', true)
      const getDetail = await this.$store.dispatch('shop/getShopPresetDetail', {
        presetType: 'details',
        presetId: this.presetId
      })
      const detail = getDetail && getDetail.message
      if (detail && detail.presetId) {
        const detailInfo = detail.presetOptions[0]
        this.name = detail.presetName
        this.title = detailInfo.title
        this.desc = detailInfo.desc
        this.descPositionBottom = detailInfo.descPositionBottom || false
        if (detailInfo.style?.fontSize) {
          this.fontSize = detailInfo.style.fontSize
        }
      }
      this.$store.commit('onLoading', false)
    },
    close () {
      this.$emit('close')
    },
    async save () {
      const presetId = this.presetId && this.presetId !== 'new' && this.presetId
      const data = {
        presetType: 'details',
        presetId: presetId || UNIQUE.uniqueId8(),
        presetName: this.name,
        presetOptions: [{
          id: UNIQUE.uniqueId8(),
          name: this.name,
          type: this.promotionType,
          title: this.title,
          desc: this.desc,
          style: {
            fontSize: this.fontSize
          },
          descPositionBottom: this.descPositionBottom
        }]
      }
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('shop/putShopPreset', data)
      if (res && res.status === 200) {
        alert(this.locale.complete_save)
        this.$emit('reload', data.presetId)
        this.close()
      }
      this.$store.commit('onLoading', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 360px;
  }
}
.isRequired {
  .innerTitle {
    padding-left: 18px;
    &:after {
      content: "*";
      position: absolute;
      top: 0;
      left: 8px;
      color: $color-red;
    }
  }
}
</style>
